'use client';

import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { AuthProvider } from './auth';
import { SearchProvider } from './search';
import { ToastContainer } from 'react-toastify';
import { FullScreenSearchProvider } from './fullscreensearch';
import AnalyticsProvider from '@components/analytics/AnalyticsProvider';

const CLIENT_ID = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID || 'INSERT_AUTH0_CLIENT_ID';
const DOMAIN = process.env.NEXT_PUBLIC_AUTH0_DOMAIN || 'INSERT_AUTH0_DOMAIN';
const AUDIENCE = process.env.NEXT_PUBLIC_AUTH0_AUDIENCE || 'INSERT_AUTH0_AUDIENCE';

const GlobalProviders = ({ children }) => {
  return (
    <Auth0Provider
      domain={DOMAIN}
      clientId={CLIENT_ID}
      authorizationParams={{
        audience: AUDIENCE
      }}
    >
      <AuthProvider>
        <FullScreenSearchProvider>
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            pauseOnHover
            draggable={false}
            theme="colored"
          />
          <SearchProvider>
            <AnalyticsProvider>{children}</AnalyticsProvider>
          </SearchProvider>
        </FullScreenSearchProvider>
      </AuthProvider>
    </Auth0Provider>
  );
};

export default GlobalProviders;
